import React, {Component, Fragment} from "react";
import 'chart.js/auto';
import { Bar } from "react-chartjs-2";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import {getMessage} from "./util";

class VotesByHour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      votes: null,
      loading: false
    };
  }

  componentDidMount() {
    this.loadVotesByHour(this.props.election_id);
  }
  loadVotesByHour = election_id => {
    this.setState({ loading: true }, () =>
      // El endpoint se renombro a /votesByTimeSlot y el campo hourly a time_slot.
      axios({
        method: "get",
        url:
          process.env.REACT_APP_BACKUP_URL +
          "/" +
          this.props.election_id +
          "/votesByTimeSlot.json"
      })
        .then(response => {
          this.setState({
            loading: false,
            votes: Object.entries(response.data.time_slot).map(function(v) {
              return { x: 1000 * parseInt(v[0]), y: v[1].electronic_voted };
            })
          });
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            axios({
              method: "get",
              url:
                process.env.REACT_APP_API_URL +
                "/election/" +
                election_id +
                "/votesByTimeSlot"
            })
              .then(response => {
                this.setState({
                  loading: false,
                  votes: Object.entries(response.data.time_slot).map(function(v) {
                    return {
                      x: 1000 * parseInt(v[0]),
                      y: v[1].electronic_voted
                    };
                  })
                });
              })
              .catch(error => {
                this.setState({ loading: false });
              });
          } else {
            this.setState({ loading: false });
          }
        })
    );
  };

  render() {
    if (this.state.votes === null) {
      return <div>{this.state.loading && <LoadingSpinner />}</div>;
    } else {
      // El eje de tiempo de chart.js v2 no existe en v3 y exigiria un adaptador de fechas:
      // se arma un eje de categorias con las franjas ya formateadas, como el resto de los boletines.
      const resolution = this.state.votes.length > 1
        ? this.state.votes[1].x - this.state.votes[0].x
        : 3600000;
      const fmt_fecha = new Intl.DateTimeFormat('es-es', {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
      });
      const fmt_hora = new Intl.DateTimeFormat('es-es', {hour: 'numeric', minute: 'numeric'});
      const etiqueta = (x, con_fecha) => {
        const desde = new Date(x);
        const hasta = new Date(x + resolution);
        return ((con_fecha ? fmt_fecha.format(desde) : fmt_hora.format(desde)) + " - " + fmt_hora.format(hasta));
      };

      const data = {
        labels: this.state.votes.map((v, i) => etiqueta(v.x, i === 0)),
        datasets: [
          {
            label: "Votos Electrónicos ",
            backgroundColor: "#C6CCD4",
            data: this.state.votes.map(v => v.y),

          }
        ]
      };

      const chartOptions = {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      };

      return (
          <Fragment>

          {this.state.votesByHour !== null && (
            <Fragment>
              <div className="row justify-content-center EvColor text-white">
                <div className="col-12 col-sm-11 col-md-9 col-lg-7  p-3">
                  <h4>{getMessage('votes_hour_title',this.props.messages)}</h4>
                </div>
              </div>
              <br/>
              <div className="row justify-content-center ">
                <div className="col-12 col-sm-11 col-md-9 col-lg-7 EvColorGrisLight">
                  <Bar data={data} options={chartOptions} />
                </div>
              </div>
            </Fragment>
          )}
          </Fragment>
      );
    }
  }
}

export default VotesByHour;
